import { BASE_ASSETS_URL } from "../utils/constants.js"

const EnvironmentPage = ({ text, settings }) => {
    // TODO: select different image, trim
    return (
        <div className="drocker-body">
            <div className="position-relative">
                <div className="drocker-responsive-image" style={{ backgroundImage: `url(${BASE_ASSETS_URL}images/drockerhof_balcony_forestview_1.jpg)` }}></div>
                <div className="container drocker-h1-container">
                    <h1 className="text-white mb-0 drocker-title-outline">{text.environmentTitle}</h1>
                </div>
            </div>
            <div className="container pt-5">
                <iframe title="day-trip-map" src={`${BASE_ASSETS_URL}html/day_trip_map_widget.html#${settings.language}`} className="drocker-map-widget"></iframe>
            </div>
        </div>
    )
}

export default EnvironmentPage
